import styled from 'styled-components';
import Styles from '@widgets/shared/styles/modal';
export const Wrapper = styled.div ``;
export const Inner = styled(Styles.Inner) `
  padding: 0;
  max-width: 35.5rem;
  border-radius: var(--border-radius-lg);
  
  ${Styles.Close} {
    z-index: 3;
  }
`;
export const Content = styled.div `
  color: var(--text);
  padding: 1.5rem;
  
  p, small {
    font-weight: 500;
  }
  
  .h3 {
    margin-bottom: 1rem;
    display: inline-block;
  }
  
  small {
    line-height: 1.17;
  }
  
  p + .btn,
  div + .btn {
    margin-top: 1.5rem;
  }
`;
export default {
    Wrapper,
    Inner,
    Content,
};
